import { getStoreByControlId } from "./image-tools";

export function createConnectionLine(host: HTMLElement, controlId?: string): SVGLineElement {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.classList.add("connection-line");
  svg.style.position = "absolute";
  svg.style.top = "0";
  svg.style.left = "0";
  svg.style.width = "100%";
  svg.style.height = "100%";
  svg.style.pointerEvents = "none";
  svg.style.zIndex = "9999999999";
  const store = controlId ? getStoreByControlId(controlId) : null;
  const color = store?.connectionlinecolor ?? "#216aff";

  const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
  line.style.pointerEvents = "stroke";
  line.setAttribute("stroke", color);
  line.setAttribute("stroke-width", "3");

  svg.appendChild(line);
  host.appendChild(svg);

  (line as any)._svg = svg;

  return line;
}
